import { Grid, Input, NativeSelect, Paper } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DatePicker, { registerLocale } from 'react-datepicker';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import Pagination from 'react-js-pagination';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../../components/Loading';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import { findPermission, TOKEN_PAGINATION } from '../../services/auth';
import useStyles from './style';
import { handleErrorRequest } from '../../utils/errorsValidation';

export function TimeCard() {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [timeCard, setTimeCard] = useState([]);
  const [frequencies, setFrequencies] = useState([]);

  const [employee, setEmployee] = useState('');
  const [cpfInput, setCpfInput] = useState('');
  const [dataInput, setDataInput] = useState();
  const [status, setStatus] = useState('ativo');
  const [antecipacaoInput, setAntecipacaoInput] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: false,
          paging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
            color: rowData.corFonte ? rowData.corFonte : 'auto',
          })
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(1887, 'Alterar')) {
            window.location.href = window.location.origin + `/app/cartoes-ponto/${rowData.cartaoPontoId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Data',
            field: 'dataPonto',
            filtering: true,
            type: 'date',
            dateSetting: {
              format: 'HH:mm',
            },
            cellStyle: {
              width: '50px',
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Colaborador',
            field: 'colaboradorNome',
            cellStyle: {
              width: '300px',
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'CPF',
            field: 'colaboradorCpf',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Entrada',
            field: 'ponto1',
            type: 'time',
            dateSetting: {
              format: 'HH:mm',
            },
            cellStyle: {
              width: '60px',
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (item) => <span>{item.ponto1 ? item.ponto1.substr(11, 5) : ''}</span>,
          },
          {
            title: 'Saida Almoço',
            field: 'ponto2',
            type: 'time',
            dateSetting: {
              format: 'HH:mm',
            },
            cellStyle: {
              width: '30px',
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (item) => <span>{item.ponto2 ? item.ponto2.substr(11, 5) : ''}</span>,
          },
          {
            title: 'Retorno Almoço',
            field: 'ponto3',
            type: 'time',
            dateSetting: {
              format: 'HH:mm',
            },
            cellStyle: {
              width: '30px',
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (item) => <span>{item.ponto3 ? item.ponto3.substr(11, 5) : ''}</span>,
          },
          {
            title: 'Saida',
            field: 'ponto4',
            type: 'time',
            dateSetting: {
              format: 'HH:mm',
            },
            width: '50px',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (item) => <span>{item.ponto4 ? item.ponto4.substr(11, 5) : ''}</span>,
          },
          {
            title: 'Sobra/Falta',
            field: 'sobraFalta',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(1887, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/cartoes-ponto/${rowData.cartaoPontoId}/visualizar`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(1887, 'Alterar') && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/cartoes-ponto/${rowData.cartaoPontoId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={timeCard}
      />
    ),
    [timeCard],
  );

  const fetchFilterOptions = async () => {
    const freq = await api.get('FrequenciasAntecipacoes/Consultar?status=Ativo');
    setFrequencies(freq.data.resposta);
  };

  const toISODate = (date) => {
    const dia = date.substr(0, 2);
    const mes = date.substr(3, 2);
    const ano = date.substr(6, 4);

    try {
      const testarData = new Date(`${ano}-${mes}-${dia}`);
    } catch (error) {
      return '';
    }

    return `${ano}-${mes}-${dia}`;
  };

  const fetchTimeCard = async (
    pageNumber = currentPage,
    currentlyStatus = status,
    itensPage = itensPerPage,
    currentlyAntec = antecipacaoInput,
  ) => {
    setLoading(true);

    try {
      let apiURL = `CartoesPontos/ConsultarGridCadastro?itensPorPagina=${itensPage}&paginaInicial=${pageNumber}&colaboradorNome=${employee}&colaboradorCpf=${cpfInput}`;
      if (dataInput != null) {
        console.log(dataInput);
        const dataFiltro = toISODate(dataInput);
        console.log(dataFiltro);
        apiURL += `&dataPonto=${dataFiltro}`;
      }

      const response = await api.get(apiURL);

      if (response?.data?.status !== 'Inconsistencia') {
        setPagination(response.data.paginacao);
        if(response.data.paginacao.qtdTotalRegistros > 0) {
          setTimeCard(response.data.resposta);
        } else {
          setTimeCard([]);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchTimeCard(pageNumber);
  };

  function dateMask(value) {
    value = value.replace('/', '').replace('/', '');
    const length = value.length;

    if (length >= 5) {
      value = value.substr(0, 2) + '/' + value.substr(2, 2) + '/' + value.substr(4, 4);
    } else if (length >= 3) {
      value = value.substr(0, 2) + '/' + value.substr(2, 2);
    }
    return value;
  }

  const handleDate = (value) => {
    setDataInput(dateMask(value));
  };

  useEffect(() => {
    setDataInput();
    fetchFilterOptions();
    const userPage = JSON.parse(sessionStorage.getItem(TOKEN_PAGINATION)).paginacao.itensPorPagina;
    setItensPerPage(userPage === 0 ? 50 : userPage);
  }, []);

  useEffect(() => {
    setDataInput(dateMask(new Date().toLocaleDateString('pt-BR')));
  }, []);

  useEffect(() => {
    setCurrentPage(1);

    const delayDebounceFn = setTimeout(() => {
      fetchTimeCard();
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [cpfInput, employee, dataInput]);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Cartões Pontos"
        back="/app/home"
        create={() => history.push('/app/cartoes-ponto/cadastrar')}
      />
      <div style={{ background: 'red', width: '100%' }}>VOLTAR</div>
      <div className={classes.content}>
        <div className={classes.rootForm}>
          <Grid container className={classes.searchContainer}>
            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>Colaborador</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  value={employee}
                  placeholder="Colaborador"
                  onChange={(e) => setEmployee(e.target.value)}
                  inputProps={{style: { textTransform: "uppercase" }}}
                />
              </Paper>
            </Grid>
            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>CPF</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  value={cpfInput}
                  placeholder="CPF"
                  onChange={(e) => setCpfInput(e.target.value)}
                />
              </Paper>
            </Grid>

            <Grid item xs={2} className={classes.item}>
              <label className={classes.label}>Data</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.dateInput}
                  value={dataInput}
                  type="text"
                  placeholder="Data"
                  onChange={(e) => {
                    handleDate(e.target.value);
                  }}
                  locale="ptBR"
                />
              </Paper>
            </Grid>

            <Grid
              item
              xs={2}
              className={classes.item}
              style={{ margin: '0 0 0 auto', display: 'flex', justifyContent: 'flex-end' }}
            >
              <button className={classes.buttonFilter} onClick={() => fetchTimeCard()}>
                Aplicar Filtro
              </button>
            </Grid>
          </Grid>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {memoizedTable}
              <div className="footer-table">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itensPerPage}
                  totalItemsCount={pagination.qtdTotalRegistros}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
                <div className="select-page">
                  <label>Qtd. por página</label>
                  <NativeSelect
                    onChange={(e) => {
                      fetchTimeCard(currentPage, status, Number(e.currentTarget.value));
                      setItensPerPage(Number(e.currentTarget.value));
                    }}
                    value={itensPerPage}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </NativeSelect>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
